import React from "react"

function Footer(){
    return(
        <footer className="py-2 mt-auto">
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-end small">
          <div className="text-muted">© {new Date().getFullYear()} North Carolina Baptist Men. All Rights Reserved.</div>
        </div>
      </div>
    </footer>
    )
}

export default Footer